import styled from 'styled-components';

const ButtonWrapper = styled.div`
    height: 14px;
    margin-top: 4px;
`;

export default ButtonWrapper;
